import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Routes } from '@angular/router';
import { SourceStore } from '@examdojo/source';
import { CmsUrlParts } from '../cms/cms.model';
import { SourceEditorContainerComponent } from './editor-container/source-editor-container.component';
import { SourceListContainerComponent } from './list-container/source-list-container.component';

export const SOURCE_ROUTES: Routes = [
  {
    path: CmsUrlParts.Sources,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: SourceListContainerComponent,
      },
      {
        canActivate: [updateActiveEntityOnParamChange],
        path: ':id',
        component: SourceEditorContainerComponent,
      },
    ],
  },
];

export function updateActiveEntityOnParamChange(route: ActivatedRouteSnapshot): boolean {
  inject(SourceStore).setActive(route.params['id']);
  return true;
}
